import { Component, OnInit } from '@angular/core';
import { Cluster } from "../../../models/cluster.model";
import { Subscription } from "rxjs";
import { ClustersService } from "../../../services/clusters.service";
import { StrategyParameters } from "../../../models/strategy-parameters.model";
import { ListsService } from 'src/app/services/lists.service';
import { StrategiesService } from "../../../services/strategies.service";
import { StrategyType } from "../../../models/strategy-type.model";
import { CurrentPortfolio } from "../../../models/current-portfolio.model";
import { FactorStrategy } from "../../../models/factor-strategy.model";
import { NotificationsService } from "../../../services/notifications.service";
import { Router } from "@angular/router";
import {MatTabChangeEvent} from "@angular/material/tabs";

@Component({
  selector: 'app-strategy-implement',
  templateUrl: './strategy-implement.component.html',
  styleUrls: ['./strategy-implement.component.scss']
})
export class StrategyImplementComponent implements OnInit {

  currentCluster: Cluster;
  currentClusterSubscription: Subscription;

  currentOriginal: CurrentPortfolio;
  currentOriginalSubscription: Subscription;
  defaultStrategy: FactorStrategy;
  defaultStrategySubscription: Subscription;
  customizedStrategy: FactorStrategy;
  customizedStrategySubscription: Subscription;

  hasOriginal: boolean = false;
  hasDefault: boolean = false;
  hasCustomized: boolean = false;
  disableActions: boolean = false;

  strategyParameters: StrategyParameters;
  strategyParametersSubscription: Subscription;

  strategyTypeList: StrategyType[];

  selectedAnalyticsTab: string = 'exposure';

  constructor(private router: Router,
              private clustersService: ClustersService,
              private listsService: ListsService,
              private strategiesService: StrategiesService,
              private notificationsService: NotificationsService) { }

  ngOnInit(): void {
    this.subscribeToCurrentCluster();
    this.subscribeToCurrentOriginal();

    this.subscribeToCurrentDefaultStrategy();
    this.subscribeToStrategyParameters();

    this.listsService.loadLists().then(
      () => {
        this.strategyTypeList = this.listsService.getStrategyTypeList();
      }
    );
  }

  subscribeToCurrentCluster() {
    this.currentClusterSubscription = this.clustersService.currentClusterSubject.subscribe(
      (cluster: Cluster) => {
        this.currentCluster = cluster;
      }
    );
    this.clustersService.emitCurrentCluster();
  }

  subscribeToCurrentOriginal() {
    this.currentOriginalSubscription = this.clustersService.currentOriginalSubject.subscribe(
      (original_portfolio: CurrentPortfolio) => {
        this.currentOriginal = original_portfolio;
        this.hasOriginal = (original_portfolio!=undefined);
      }
    );
    this.clustersService.emitCurrentOriginal();
  }

  subscribeToCurrentDefaultStrategy() {
    this.defaultStrategySubscription = this.strategiesService.defaultStrategySubject.subscribe(
      (strategy: FactorStrategy) => {
        this.defaultStrategy = strategy;
        this.hasDefault = (strategy!=undefined);
      }
    );
    this.customizedStrategySubscription = this.strategiesService.customizedStrategySubject.subscribe(
      (strategy: FactorStrategy) => {
        this.customizedStrategy = strategy;
        this.hasCustomized = (strategy!=undefined);
      }
    );

    this.strategiesService.emitDefaultStrategy();
    this.strategiesService.emitCustomizedStrategy();
    this.strategiesService.emitStrategyBenchmark();
  }

  subscribeToStrategyParameters() {
    this.strategyParametersSubscription = this.strategiesService.strategyParametersSubject.subscribe(
      (strategyParameters: StrategyParameters) => {
        this.strategyParameters = strategyParameters;
      }
    );
    this.strategiesService.emitStrategyParameters();
  }

  onStrategySelection(strategyType: StrategyType) {
    this.strategiesService.changeSelectedStrategy(strategyType.alias);
  }

  onAnalyticsTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Exposure':            this.selectedAnalyticsTab='exposure'; break;
      case 'Absolute':            this.selectedAnalyticsTab='absolute'; break;
      case 'Relative':            this.selectedAnalyticsTab='relative'; break;
      case 'Rating':              this.selectedAnalyticsTab='rating'; break;
      case 'Robustness':          this.selectedAnalyticsTab='robustness'; break;
    }
  }

  async onImplement() {
    this.notificationsService.runSpinner();
    this.disableActions = true;

    try {
      await this.strategiesService.computeCustomStrategy(this.strategyParameters, this.currentCluster, true);
      await this.clustersService.select(this.currentCluster.id);

      this.disableActions = false;
      this.notificationsService.stopSpinner();
      this.router.navigate(['/tools/investable-solution']);
    } catch (e) {
      // Display error
      this.notificationsService.notify('strategy/create-failed');
    }

    this.disableActions = false;
    this.notificationsService.stopSpinner();
  }

}
